import { Link } from 'react-router-dom';

export default function ArticleCTA() {
  return (
    <section className="relative w-full h-[350px] md:h-[420px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20cozy%20reading%20atmosphere%2C%20warm%20evening%20reading%20nook%2C%20soft%20ambient%20lighting%2C%20comfortable%20space%2C%20Korean%20digital%20art%20style%2C%20rich%20amber%20and%20cream%20tones&width=1800&height=900&seq=article-cta-reading&orientation=landscape"
        alt="订阅更新"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 w-full h-full max-w-7xl mx-auto px-4 md:px-6 flex flex-col items-center justify-center text-center">
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-white tracking-wide mb-3">
          追更不迷路
        </h2>
        <p className="text-white/65 text-sm md:text-base max-w-md mb-8">
          订阅邮箱通知，第一时间获取最新章节更新
          <br />免费韩漫大全，下拉式高效阅读
        </p>
        <Link
          to="/"
          className="group inline-flex items-center gap-3 px-8 py-3.5 bg-foreground-950 hover:bg-foreground-900 text-white rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer"
        >
          <span className="w-7 h-7 rounded-full bg-accent-500 flex items-center justify-center">
            <i className="ri-bookmark-line text-white text-xs"></i>
          </span>
          加入书架
          <i className="ri-arrow-right-up-line transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"></i>
        </Link>
      </div>
    </section>
  );
}